import { background, chevronRight } from "@wordpress/icons";
import React from "react";
import { AppHeader } from "./components/AppHeader";
import { General, Updates, Sizes, ApiKeys } from "./components/settings";
import DevToggleWrapper from "./components/DevComponent";
const { __ } = wp.i18n;

import { Button } from "@wordpress/components";
import { useRef } from "react";

import { useEffect, useState } from "react";

const ScrollableMenu = () => {
	const sectionsRef = useRef([]);
	const [visibleSection, setVisibleSection] = useState(null);

	// Scroll to the section when a button is clicked
	const scrollToSection = (index) => {
		if (sectionsRef.current[index]) {
			sectionsRef.current[index].scrollIntoView({
				behavior: "smooth",
				block: "start",
				inline: "start"
			});
		}
	};

	// Set up IntersectionObserver to detect which section is visible
	useEffect(() => {
		const options = {
			threshold: 0.8,
			rootMargin: "-100px 0px 0px 0px"
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const index = sectionsRef.current.findIndex(
					(el) => el === entry.target,
				);

				if (entry.isIntersecting) {
					setVisibleSection(index);
				}
			});
		}, options);

		// Observe each section
		sectionsRef.current.forEach((section) => {
			if (section) {
				observer.observe(section);
			}
		});

		// Clean up observer on component unmount
		return () => {
			observer.disconnect();
		};
	}, []);

	const sectionTitles = [
		"General",
		"Image Sizes",
		"Api Keys",
		"Updates & Changelog",
	];

	return (
		<DevToggleWrapper>
			<div
				className="image-hub-scroll-container"
				style={{
					display: "flex",
					minHeight: "calc(100vh - 190.14px)",
					background: "white",

				}}
			>
				<div
					style={{
						display: "flex",
						padding: "15px",
						background: "white",
						flexDirection: "column",
						boxShadow: "2px 0px 5px 0px rgba(0,0,0,0.37) !important",
						position: "sticky",
						top: "calc( 118px + 32px )",
						height: "100%"
					}}
				>
					{sectionTitles.map((title, index) => (
						<Button
							key={index}
							className={`image-hub-settings-swipable-menu-button ${visibleSection === index ? "active" : ""}`}
							__next40pxDefaultSize
							icon={chevronRight}
							iconPosition="right"
							variant="primary"
							onClick={() => scrollToSection(index)}
							style={{ margin: "0 15px" }}
						>
							{title}
						</Button>
					))}

				</div>
				<div
					style={{
						flex: 1,
						padding: "0 20px",
						background: "white",
					}}
				>
					<General key={0} ref={(el) => (sectionsRef.current[0] = el)} />
					<hr />
					<Sizes key={1} ref={(el) => (sectionsRef.current[1] = el)} />
					<hr />
					<ApiKeys key={2} ref={(el) => (sectionsRef.current[2] = el)} />
					<hr />
					<Updates key={3} ref={(el) => (sectionsRef.current[3] = el)} />
				</div>
			</div>
		</DevToggleWrapper>
	);
};

export const SettingsApp = () => {
	return (
		<div style={{ display: "flex", flexDirection: "column" }}>
			<AppHeader enableBrowseButton={true} style={{
				position: "sticky",
				top: "32px",
				background: "#F0F0F0",
				zIndex: "999"

			}} />

			<ScrollableMenu />
		</div>
	);
};